import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from 'contexts/AuthContext';

const GlobalNavbar = () => {
  const { booker, isAuthenticated, isAdmin, logout } = useAuth();
  const navigate = useNavigate();

  const handleSignOut = () => {
    logout();
    navigate('/login');
  };

  return (
    <nav className="bg-gray-100 border-b border-brand-border">
      <div className="max-w-5xl mx-auto px-4 md:px-6 py-3 flex items-center justify-between">
        <Link to="/" className="flex items-center">
          <img
            src="/images/logo-dark.png"
            alt="Kirsebærkroen"
            className="h-12 md:h-14 w-auto"
          />
        </Link>
        <div className="flex items-center gap-3">
          <span className="text-brand-gold text-xs font-medium tracking-wide uppercase hidden md:inline">
            Agent Portal
          </span>
          <div className="h-6 w-px bg-brand-border hidden md:block"></div>
          <img
            src="/images/nordic-logo.webp"
            alt="Nordic"
            className="h-8 md:h-10 w-auto"
          />
          {isAuthenticated && booker && (
            <>
              <div className="h-6 w-px bg-brand-border hidden md:block"></div>
              <Link
                to="/calendar"
                className="text-xs font-medium text-brand-gold hover:text-amber-700 transition-colors"
              >
                Calendar
              </Link>
              {isAdmin && (
                <Link
                  to="/admin"
                  className="text-xs font-medium text-brand-gold hover:text-amber-700 transition-colors"
                >
                  Admin
                </Link>
              )}
              <span className="text-sm text-brand-dark hidden md:inline">{booker.name}</span>
              <button
                onClick={handleSignOut}
                className="text-xs text-brand-muted hover:text-brand-dark transition-colors"
              >
                Sign out
              </button>
            </>
          )}
        </div>
      </div>
    </nav>
  );
};

export default GlobalNavbar;
